<app-sg-aria-message [errorMessageModelArray]="errorMessageModelArray"></app-sg-aria-message>
<h2 id="mainTitle">供給先関連情報</h2>

<!-- 基本情報コンポーネント -->

<app-sgke390d-info *ngIf="initResponse" [initResponse]="initResponse" [visitormei]="dialogData.visitormei"
  [codeMap]="codeMap">
</app-sgke390d-info>